import React, { Component } from 'react';
import { request } from "../../util/APIUtils";
import { deepCopyObject, showAxiosError } from "../../util/Helpers";
import { Button, Form, input, Modal } from "antd";
import Select from "react-select"
import Alert from "react-s-alert";
import { validateComponent } from "../../common/validation";
import { Label } from "reactstrap";
import './PharmacyList.css';
import { API_BASE_URL } from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import 'react-datetime/css/react-datetime.css';
import { Map, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
    iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});


const { } = input;

class PharmacyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: false,
            mode: this.props.mode,
            selectedUsers: null,
            selectedGroups: null,
            isMapModalVisible: false,
            selectedLocation: null,
            selectedMemberName: "",
            selectedMemberOption: null,
            pharmacyInfo: {
                dutyParameters: null,
                id: this.props.selectedPharmacy ? this.props.selectedPharmacy.id : null,
                name: "",
                phone: "",
                location: "",
                district: "",
                latitude: "",
                longitude: "",
                region: {
                    id: this.props.selectedPharmacy ? (this.props.selectedPharmacy.regionId ? this.props.selectedPharmacy.regionId : null) : null,
                    regionName: ""
                },
                inAvm: this.props.selectedPharmacy ? this.props.selectedPharmacy.inAvm : false,
                selectedRegion: null,
                memberName: "",
                memberLastName: "",
                tcKimlikNo: "",
                uyeId: null,
            },
            abdullah: {
                id: "",
            },
            regions: [],
        };

        this.savePharmacy = this.savePharmacy.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.listRegion = this.listRegion.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
        this.openMapModal = this.openMapModal.bind(this);
        this.closeMapModal = this.closeMapModal.bind(this);
        this.handleMapClick = this.handleMapClick.bind(this);
        this.saveSelectedLocation = this.saveSelectedLocation.bind(this);
    }

    openMapModal() {
        console.log("Modal açılıyor...");
        this.setState({ isMapModalVisible: true });
    }

    closeMapModal() {
        this.setState({ isMapModalVisible: false });
    }

    handleMapClick(e) {
        const coords = e.get('coords');
        this.setState({
            selectedLocation: { latitude: coords[0], longitude: coords[1] }
        });
    }

    saveSelectedLocation() {
        const { selectedLocation, pharmacyInfo } = this.state;
        if (selectedLocation) {
            const updatedPharmacy = { ...pharmacyInfo };
            updatedPharmacy.latitude = Number(selectedLocation.latitude.toFixed(7));
            updatedPharmacy.longitude = Number(selectedLocation.longitude.toFixed(7));

            this.setState({
                pharmacyInfo: updatedPharmacy,
                isMapModalVisible: false
            });
        }
    }

    componentDidMount() {
        if (this.props.selectedPharmacy) {
            const pharmacy = deepCopyObject(this.props.selectedPharmacy);
            if (!pharmacy.region) pharmacy.region = { id: null, regionName: "" };
            if (!pharmacy.tcKimlikNo) pharmacy.tcKimlikNo = "";

            this.setState({
                pharmacyInfo: {
                    ...this.state.pharmacyInfo,
                    ...pharmacy,
                    tcKimlikNo: pharmacy.tcKimlikNo || "",
                },
                selectedMemberName: this.props.selectedPharmacy.memberName + " " + this.props.selectedPharmacy.memberLastName,
                cities: this.props.cities
            }, () => {
                this.listRegion(); // callback içinde çağır → overwrite olmaz
            });
        } else {
            this.setState({
                cities: this.props.cities,
            })
            this.listRegion();
        }
    }

    listRegion() {
        let self = this;
        let url = API_BASE_URL + "/regions"; // Sayfa ve pageSize eklemek gerekmiyor

        let params = {
            url,
            method: "GET",
        };

        self.setState({ loading: true });
        request(params)
            .then((response) => {
                this.setState({
                    regions: response.data.content || response.data || [],
                    loading: false,
                });
            })
            .catch((error) => {
                this.setState({ loading: false, error: "Bölgeler yüklenirken bir sorun oluştu." });
                console.error("Hata:", error);
            });
    }

    validateField = (e) => {
        const { name, value } = e.target;
        let error = this.state.error;

        if (name === 'name') {
            if (!value.trim()) {
                error[name] = { valid: false, message: 'Eczane Adı boş olamaz' };
            } else if (value.length < 3 || value.length > 50) {
                error[name] = { valid: false, message: 'Eczane Adı 3 ile 50 karakter arasında olmalıdır' };
            } else {
                error[name] = { valid: true, message: '' };
            }
        }

        if (name === 'phone') {
            const phoneRegex = /^[0-9]{10,15}$/; // Telefon numarası için regex
            if (!value.trim()) {
                error[name] = { valid: false, message: 'Telefon boş olamaz' };
            } else if (!phoneRegex.test(value)) {
                error[name] = { valid: false, message: 'Telefon numarası 10 ile 15 rakam arasında olmalıdır' };
            } else {
                error[name] = { valid: true, message: '' };
            }
        }

        if (name === 'region') {
            if (!value) {
                error[name] = { valid: false, message: 'Bölge seçilmelidir' };
            } else {
                error[name] = { valid: true, message: '' };
            }
        }

        this.setState({ error });
    };


    onChangeSelect(name, value) {
        let pharmacyInfo = this.state.pharmacyInfo;
        if (value === null) {
            pharmacyInfo[name] = null
        } else {
            pharmacyInfo[name] = value.value;
        }
        this.setState({ pharmacyInfo });
    }

    onSelectInfoChange(name, value) {
        let pharmacyInfo = this.state.pharmacyInfo;
        if (value === null) {
            pharmacyInfo[name] = [];
        } else {
            pharmacyInfo[name] = [];
            pharmacyInfo[name] = value.slice();
        }
        this.setState({ pharmacyInfo });
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }


    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let pharmacyInfo = this.state.pharmacyInfo;
        pharmacyInfo[name] = value;
        this.setState({ pharmacyInfo });
    }

    onChangeDocumentUpperCase(name, value) {
        this.setState((prevState) => {
            const pharmacyInfo = { ...prevState.pharmacyInfo };
            if (name === "region") {
                pharmacyInfo.region = { ...pharmacyInfo.region, id: value };
            } else if (name === "inAvm") {
                pharmacyInfo.inAvm = value;
            } else {
                pharmacyInfo[name] = value.toString().toLocaleUpperCase("tr-TR");
            }
            return { pharmacyInfo };
        });
    }

    findMemberByTc(tc) {
        request({
            url: API_BASE_URL + "/ws/find-by-tc?tc=" + tc,
            method: "GET"
        })
            .then(res => {
                const member = res.data;

                let pharmacyInfo = this.state.pharmacyInfo;
                pharmacyInfo.uyeId = member.id;
                pharmacyInfo.memberId = member.id;
                pharmacyInfo.memberName = member.ad;
                pharmacyInfo.meberLastName = member.soyad;

                this.setState({
                    pharmacyInfo,
                    selectedMemberName: member.ad + " " + member.soyad
                });

                if (!this.props.selectedPharmacy) {
                    Alert.success("Üye bulundu: " + member.ad + " " + member.soyad);
                }
            })
            .catch(() => {
                this.setState({
                    selectedMemberName: "",
                    pharmacyInfo: {
                        ...this.state.pharmacyInfo,
                        uyeId: null
                    }
                });

                Alert.error("Bu TC kimlik numarasına ait aktif üye bulunamadı.");
            });
    }


    onChangeDocumentLowerCase(name, value) {
        this.setState((prevState) => {
            const pharmacyInfo = { ...prevState.pharmacyInfo };
            if (name === "region") {
                pharmacyInfo.region = { ...pharmacyInfo.region, id: value };
            } else if (name === "inAvm") {
                pharmacyInfo.inAvm = value;
            } else {
                pharmacyInfo[name] = value.toString().toLocaleLowerCase("tr-TR");
            }
            return { pharmacyInfo };
        });
    }

    onSelectChange(name, value) {
        let pharmacyInfo = this.state.pharmacyInfo;
        if (value === null) {
            pharmacyInfo[name] = null
        } else {
            pharmacyInfo[name] = value.value;
        }
        this.setState({ pharmacyInfo });
    }


    savePharmacy(action) {
        let self = this;
        let pharmacyInfo = this.state.pharmacyInfo;

        if (!pharmacyInfo.name) {
            Alert.error("Eczane Adı boş olmamalıdır!");
            return;
        }
        if (!pharmacyInfo.phone) {
            Alert.error("Telefon alanı boş olmamalıdır!");
            return;
        }
        if (!pharmacyInfo.region || !pharmacyInfo.region.id) {
            Alert.error("Bölge alanı boş olmamalıdır!");
            return;
        }
        if (!pharmacyInfo.location || !pharmacyInfo.location.trim()) {
            Alert.error("Adres zorunludur!");
            return;
        }
        if (!pharmacyInfo.tcKimlikNo || pharmacyInfo.tcKimlikNo.length !== 11) {
            Alert.error("TC Kimlik No zorunludur ve 11 haneli olmalıdır!");
            return;
        }
        if (!pharmacyInfo.memberId) {
            Alert.error("TC numarasına ait eczacı bulunmadan kayıt yapılamaz!");
            return;
        }
        let token = localStorage.getItem("accessToken");

        let dto = {
            id: pharmacyInfo.id,
            name: pharmacyInfo.name,
            phone: pharmacyInfo.phone,
            location: pharmacyInfo.location,
            district: pharmacyInfo.district,
            latitude: pharmacyInfo.latitude,
            longitude: pharmacyInfo.longitude,
            inAvm: pharmacyInfo.inAvm,
            regionId:
                pharmacyInfo.region && pharmacyInfo.region.id
                    ? pharmacyInfo.region.id
                    : null,
            citySubDivisionId: pharmacyInfo.citySubDivisionId ? pharmacyInfo.citySubDivisionId : null,
            cityId: pharmacyInfo.cityId ? pharmacyInfo.cityId : null,
            uyeId: pharmacyInfo.memberId
        };

        this.setState({ isLoading: true });

        let params;
        let message;

        if (!pharmacyInfo.id) {
            message = 'Eczane Bilgileri Başarıyla Kaydedildi.';
            params = {
                url: API_BASE_URL + "/pharmacies/add/",
                data: dto,
                method: 'post',
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            };
        } else {
            message = 'Eczane Bilgileri Başarıyla Güncellendi.';
            params = {
                url: API_BASE_URL + "/pharmacies/" + pharmacyInfo.id,
                data: dto,
                method: 'put',
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            };
        }

        request(params)
            .then(() => {
                Alert.success(message);
                this.setState({ isLoading: false });
                this.cancelProcess();
                this.props.handleSearch(this.props.searchQuery, true);
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                showAxiosError(error);
            });
    }


    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }


    render() {
        const city = this.state.cities && this.state.cities.find(c => Number(c.value) === this.state.pharmacyInfo.cityId);
        const citySubDivision = city && city.citySubDivisions && city.citySubDivisions.find(t => t.id === this.state.pharmacyInfo.citySubDivisionId);

        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                }
                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Eczane Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">
                                    Eczane Adı<span className="required-star">*</span> :
                                </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('name')}>
                                    <input className="form-control uppercase"
                                        type="text"
                                        name="name"
                                        id="name"
                                        maxLength="50"
                                        data-vlength="3,50"
                                        onBlur={this.validateField}
                                        ref="name"
                                        value={this.state.pharmacyInfo.name || ""}
                                        onChange={(e) => this.onChangeDocumentUpperCase("name", e.target.value)}
                                    />
                                    {this.validateMessage('name') && (
                                        <div className="validation-error">{this.validateMessage('name')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">
                                    Telefon<span className="required-star">*</span> :
                                </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('phone')}>
                                    <input className="form-control uppercase"
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        maxLength="50"
                                        data-vlength="3,50"
                                        onBlur={this.validateField}
                                        ref="phone"
                                        value={this.state.pharmacyInfo.phone || ""}
                                        onChange={(e) => this.onChangeDocumentUpperCase("phone", e.target.value)}
                                    />
                                    {this.validateMessage('phone') && (
                                        <div className="validation-error">{this.validateMessage('phone')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Adres: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('location')}>
                                    <textarea className="form-control uppercase"
                                        name="location"
                                        id="location"
                                        rows={3}
                                        style={{ minHeight: '80px', resize: 'vertical', border: '1px solid #E3E3E3', borderRadius: '4px', padding: '8px' }}
                                        onBlur={this.validateField}
                                        ref="location"
                                        value={this.state.pharmacyInfo.location || ""}
                                        onChange={(e) => this.onChangeDocumentUpperCase("location", e.target.value)}
                                    />
                                    {this.validateMessage('location') && (
                                        <div className="validation-error">{this.validateMessage('location')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">
                                    İl<span className="required-star">*</span> :
                                </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('region')}>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="region"
                                        id="region"
                                        ref="region"
                                        style={{ flex: 1 }}
                                        options={
                                            this.state.cities &&
                                            this.state.cities.map(city => ({
                                                value: Number(city.value),
                                                label: city.label,
                                            }))
                                        }
                                        value={
                                            this.state.pharmacyInfo.cityId ? {
                                                value: this.state.pharmacyInfo.cityId,
                                                label: (this.state.cities.find(r => Number(r.value) === this.state.pharmacyInfo.cityId) || {}).label
                                                    || "",
                                            }
                                                : null
                                        }
                                        onChange={option => {
                                            this.setState(prevState => ({
                                                pharmacyInfo: {
                                                    ...prevState.pharmacyInfo,
                                                    cityId: option.value,
                                                    citySubDivisionId: null,
                                                }
                                            }));
                                        }}
                                    />
                                    {this.validateMessage('region') && (
                                        <div className="validation-error">{this.validateMessage('region')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">
                                    İlçe<span className="required-star">*</span> :
                                </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('region')}>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="region"
                                        id="region"
                                        ref="region"
                                        style={{ flex: 1 }}
                                        options={
                                            this.state.cities && this.state.cities.find(c => Number(c.value) === this.state.pharmacyInfo.cityId) &&
                                            this.state.cities.find(c => Number(c.value) === this.state.pharmacyInfo.cityId).citySubDivisions.map(citySubDivisions => ({
                                                value: citySubDivisions.id,
                                                label: citySubDivisions.name,
                                            }))
                                        }
                                        value={
                                            this.state.pharmacyInfo.citySubDivisionId
                                                ? {
                                                    value: citySubDivision && citySubDivision.id && citySubDivision.id,
                                                    label: citySubDivision && citySubDivision.name && citySubDivision.name,
                                                }
                                                : null
                                        }
                                        onChange={option => {
                                            this.setState(prevState => ({
                                                pharmacyInfo: {
                                                    ...prevState.pharmacyInfo,
                                                    citySubDivisionId: option.value,
                                                }
                                            }));
                                        }}
                                    />
                                    {this.validateMessage('region') && (
                                        <div className="validation-error">{this.validateMessage('region')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Enlem: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('latitude')}>
                                    <input className="form-control uppercase"
                                        type="text"
                                        name="latitude"
                                        id="latitude"
                                        maxLength="50"
                                        data-vlength="3,50"
                                        onBlur={this.validateField}
                                        ref="latitude"
                                        value={this.state.pharmacyInfo.latitude || ""}
                                        onChange={(e) => this.onChangeDocumentUpperCase("latitude", e.target.value)}
                                    />
                                    {this.validateMessage('latitude') && (
                                        <div className="validation-error">{this.validateMessage('latitude')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Boylam: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('longitude')}>
                                    <input className="form-control uppercase"
                                        type="text"
                                        name="longitude"
                                        id="longitude"
                                        maxLength="50"
                                        data-vlength="3,50"
                                        onBlur={this.validateField}
                                        ref="longitude"
                                        value={this.state.pharmacyInfo.longitude || ""}
                                        onChange={(e) => this.onChangeDocumentUpperCase("longitude", e.target.value)}
                                    />
                                    {this.validateMessage('longitude') && (
                                        <div className="validation-error">{this.validateMessage('longitude')}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Konum Seç: </Label>
                                <div className="col-sm-8">
                                    <Button type="primary" onClick={this.openMapModal}>
                                        Haritadan Konum Seç
                                    </Button>
                                </div>
                            </div>
                            <Modal
                                title="Haritadan Konum Seç"
                                visible={this.state.isMapModalVisible}
                                onCancel={this.closeMapModal}
                                onOk={this.saveSelectedLocation}
                                okText="Kaydet"
                                cancelText="İptal"
                                width={800}
                                getContainer={() => document.body}
                                maskClosable={false}
                            >
                                <Map
                                    ref={(ref) => {
                                        this.mapRef = ref;
                                    }}
                                    center={
                                        this.state.pharmacyInfo.latitude && this.state.pharmacyInfo.longitude
                                            ? [
                                                parseFloat(this.state.pharmacyInfo.latitude),
                                                parseFloat(this.state.pharmacyInfo.longitude),
                                            ]
                                            : [37.1588, 38.7939] // Şanlıurfa merkez
                                    }
                                    zoom={15}
                                    style={{ height: "400px", width: "100%" }}
                                    onclick={(e) => {
                                        const { lat, lng } = e.latlng;
                                        this.setState({
                                            selectedLocation: { latitude: lat, longitude: lng },
                                        });
                                    }}
                                    animate={true}
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution="&copy; OpenStreetMap contributors"
                                    />

                                    {this.state.selectedLocation && (
                                        <Marker
                                            position={[
                                                this.state.selectedLocation.latitude,
                                                this.state.selectedLocation.longitude,
                                            ]}
                                        />
                                    )}

                                    {!this.state.selectedLocation &&
                                        this.state.pharmacyInfo.latitude &&
                                        this.state.pharmacyInfo.longitude && (
                                            <Marker
                                                position={[
                                                    parseFloat(this.state.pharmacyInfo.latitude),
                                                    parseFloat(this.state.pharmacyInfo.longitude),
                                                ]}
                                            />
                                        )}
                                </Map>

                                <p style={{ marginTop: 10 }}>
                                    {this.state.selectedLocation
                                        ? `Seçilen konum: Enlem ${this.state.selectedLocation.latitude.toFixed(
                                            6
                                        )}, Boylam ${this.state.selectedLocation.longitude.toFixed(6)}`
                                        : this.state.pharmacyInfo.latitude && this.state.pharmacyInfo.longitude
                                            ? `Kayıtlı konum: Enlem ${parseFloat(
                                                this.state.pharmacyInfo.latitude
                                            ).toFixed(6)}, Boylam ${parseFloat(
                                                this.state.pharmacyInfo.longitude
                                            ).toFixed(6)}`
                                            : "Haritadan bir konum seçin."}
                                </p>
                            </Modal>

                            <div className="row">
                                <Label className="col-sm-3">
                                    Bölge<span className="required-star">*</span> :
                                </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('region')}>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="region"
                                        id="region"
                                        ref="region"
                                        style={{ flex: 1 }}
                                        options={
                                            this.state.regions &&
                                            this.state.regions.map(region => ({
                                                value: region.id,
                                                label: region.regionName,
                                            }))
                                        }
                                        value={
                                            this.state.pharmacyInfo.region && this.state.pharmacyInfo.region.id
                                                ? {
                                                    value: this.state.pharmacyInfo.region.id,
                                                    label: this.state.pharmacyInfo.region.regionName
                                                        || (this.state.regions.find(r => r.id === this.state.pharmacyInfo.region.id) || {}).regionName
                                                        || "",
                                                }
                                                : null
                                        }
                                        onChange={option => {
                                            this.setState(prevState => ({
                                                pharmacyInfo: {
                                                    ...prevState.pharmacyInfo,
                                                    region: {
                                                        id: option ? option.value : null,
                                                        regionName: option ? option.label : ""
                                                    }
                                                }
                                            }));
                                        }}
                                    />
                                    {this.validateMessage('region') && (
                                        <div className="validation-error">{this.validateMessage('region')}</div>
                                    )}
                                </div>

                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Eczacı TC Kimlik No:</Label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        maxLength="11"
                                        value={this.state.pharmacyInfo.tcKimlikNo || ""}
                                        // readOnly={!!this.props.selectedPharmacy}
                                        // disabled={!!this.props.selectedPharmacy}
                                        onChange={
                                            (e) => {
                                                let tc = e.target.value;
                                                let pharmacyInfo = this.state.pharmacyInfo;
                                                pharmacyInfo.tcKimlikNo = tc;

                                                this.setState({ pharmacyInfo });

                                                if (tc.length === 11) {
                                                    this.findMemberByTc(tc);
                                                }
                                            }
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Eczane Sahibi:</Label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.selectedMemberName || "—"}
                                        readOnly
                                    />
                                </div>
                            </div>
                            {/*<div className="row">*/}
                            {/*    <Label className="col-sm-3">AVM İçinde mi ?: </Label>*/}
                            {/*    <div className={"col-sm-8 form-group" + this.validateClass('inAvm')}>*/}
                            {/*        <input className="form-control uppercase"*/}
                            {/*               type="checkbox"*/}
                            {/*               id="inAvm"*/}
                            {/*               checked={this.state.pharmacyInfo.inAvm}*/}
                            {/*               onChange={(e) => this.onChangeDocumentUpperCase("inAvm", e.target.checked)}*/}
                            {/*               name="inAvm"*/}
                            {/*               maxLength="50"*/}
                            {/*               data-vlength="3,50"*/}
                            {/*               onBlur={this.validateField}*/}
                            {/*               ref="inAvm"*/}
                            {/*        />*/}
                            {/*        {this.validateMessage('inAvm') && (*/}
                            {/*            <div className="validation-error">{this.validateMessage('inAvm')}</div>*/}
                            {/*        )}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </Form>
                    <div className="save-button-container mb-5">
                        <button onClick={() => {
                            this.savePharmacy()
                        }}
                            className="member-save-button"
                            disabled={this.state.isLoading}
                        >
                            {this.props.selectedPharmacy ? "TAMAM" : "KAYDET"}
                        </button>
                    </div>
                </div>
            </div>
        )
    }

}

export default PharmacyForm;


// WEBPACK FOOTER //
// ./src/page/pharmacyList/PharmacyForm.js